export const groupTypes = {
  users: "users",
  userGroups: "userGroups",
  masterGroups: "masterGroups",
  customGroups: "customGroups",
  jobTitles: "jobTitles",
  targetGroup: "targetGroup",
};
